import CryptoJS from 'crypto-js';

// Ofuscación: Token generado dinámicamente para evitar búsqueda directa
const _k = () => {
  const p = ['x9k2m8p4q7w1', 'e5r3t6y9u2i4', 'o7p0a3s6d9f2', 'g5h8j1k4l7z0', 'x3c6v9b2n5m8'];
  return p.join('');
};

// Utilidad de limpieza ofuscada
const _s = (v: string): string =>
  // eslint-disable-next-line no-control-regex
  v ? v.replace(/\x00/g, '').trim() : '';

// Función de desencriptación ofuscada
const _d = (e: string, k: string): string => {
  try {
    if (!e || !k) return '';

    const cv = _s(e);
    const ck = _s(k);

    const b = CryptoJS.AES.decrypt(cv, ck);
    const r = b.toString(CryptoJS.enc.Utf8);

    return r ? _s(r) : '';
  } catch {
    return '';
  }
};

// Procesador de configuración genérico
export const _p = <T>(
  cfg: Record<string, string>
): T => {
  const k = _k();
  const result: Record<string, string> = {};

  for (const [key, val] of Object.entries(cfg)) {
    result[key] = _d(val, k);
  }

  return result as T;
};

// Detector de entorno ofuscado
export const _e = (): string => {
  const env = process.env.REACT_APP_NODE_ENV || '';
  const envMap: Record<string, number> = {
    'staging': 1,
    'walmart': 2,
    'walmart_lapzo': 3,
    'development': 4,
    'production': 0
  };

  return String(envMap[env] ?? 0);
};

// Función de encriptación (inversa de _d)
export const encrypt = (plain: string, k: string = _k()): string => {
  try {
    if (!plain || !k) return '';
    return CryptoJS.AES.encrypt(_s(plain), _s(k)).toString();
  } catch {
    return '';
  }
};